import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

import { ConfirmReservationError } from 'application/modules/bookingWizard/useCases/hooks/useCaseConfirmReservation';

export type ConfirmReservationErrorCode =
  | 'slot_conflict'
  | 'appointment_unavailable'
  | 'invalid_promo_code'
  | 'unauthorized'
  | 'unknown';

const confirmReservationErrorMap: Record<ConfirmReservationErrorCode, ConfirmReservationError> = {
  slot_conflict: ConfirmReservationError.SlotConflict,
  appointment_unavailable: ConfirmReservationError.AppointmentUnavailable,
  invalid_promo_code: ConfirmReservationError.InvalidPromoCode,
  unauthorized: ConfirmReservationError.Unauthorized,
  unknown: ConfirmReservationError.Unknown,
};

export function mapConfirmReservationErrorCode(
  error: FetchBaseQueryError | SerializedError | undefined,
): ConfirmReservationErrorCode | undefined {
  if (!error) {
    return undefined;
  }

  const status =
    'status' in error
      ? typeof error.status === 'number'
        ? error.status
        : error.status === 'PARSING_ERROR' && typeof error.originalStatus === 'number'
          ? error.originalStatus
          : undefined
      : undefined;

  if (status === 409) {
    return 'slot_conflict';
  }
  if (status === 400) {
    return 'appointment_unavailable';
  }
  if (status === 512) {
    return 'invalid_promo_code';
  }
  if (status === 401) {
    return 'unauthorized';
  }
  return 'unknown';
}

export function toConfirmReservationError(
  code: ConfirmReservationErrorCode | undefined,
): ConfirmReservationError | undefined {
  if (!code) {
    return undefined;
  }
  return confirmReservationErrorMap[code];
}

export function mapConfirmReservationError(
  error: FetchBaseQueryError | SerializedError | undefined,
): ConfirmReservationError | undefined {
  return toConfirmReservationError(mapConfirmReservationErrorCode(error));
}
